<script lang="ts" setup>
defineProps<{
  navigation?: NavigationItem[]
}>()
const { loggedIn } = useUser()
</script>

<template>
  <div
    v-if="navigation"
    class="gap-3 "
  >
    <div class="flex gap-3">
      <template
        v-for="item in navigation"
        :key="item.id"
      >
        <NuxtLink
          v-if="!item?.children?.length"
          :to="item.expand?.page?.slug"
          exact-active-class="active"
          class="link"
        >
          {{ item.label }}
        </NuxtLink>
        <template v-else>
          <UDropdown
            :items="[item.children]"
            mode="hover"
          >
            <p class="link">
              {{ item.label }}
            </p>
            <template #item="{ item }">
              <NuxtLink :to="item.expand?.page?.slug">
                {{ item.label }}
              </NuxtLink>
            </template>
          </UDropdown>
        </template>
      </template>
      <NavigationNotification />
      <UPopover :ui="{ width: 'w-full md:w-2/3 lg:w-80' }">
        <div class="bg-blue p-2 rounded-full flex items-center justify-center">
          <Icon
            name="heroicons:user-16-solid"
            class="text-white"
          />
        </div>

        <template #panel="{ close }">
          <div
            :key="loggedIn"
            class="p-6 bg-white"
          >
            <UserLogin
              v-if="!loggedIn"
              inline
            />
            <NavigationProfile v-else />
          </div>
        </template>
      </UPopover>
    </div>
  </div>
</template>

<style scoped>
.link{
  @apply inline-flex items-center text-primary-700 font-display lg:text-lg hover:bg-primary-700 hover:text-yellow uppercase font-bold rounded-full px-2 py-1 md:px-3 lg:px-4 duration-100;
}
.link.active{
  @apply text-pink hover:bg-transparent;
}
.n.link{
  @apply hover:bg-transparent hover:text-primary-500 text-primary-500 pb-0;
}
</style>
